import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerModelloIntrastatModalComponent } from './worker-modello-intrastat-modal';


export const WorkerModelloIntrastatModalModule: string = ng
    .module('worker-modello-intrastat-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerModelloIntrastatModalComponent', WorkerModelloIntrastatModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-modello-intrastat-modal/worker-modello-intrastat-modal.module.ts